import { pick } from "lodash";
import { _internalApiGetRenderId } from "./Runtime.js";
import { computeRealValue } from "./compute/computeRealValue.js";
const timeoutIdList = new Set();
export function startPoll(task, _ref, pollOptions, runtimeContext) {
  let {
    progress,
    success,
    error,
    finally: finallyCallback
  } = _ref;
  const {
    expectPollStopImmediately,
    expectPollEnd
  } = pollOptions;
  const {
    interval,
    leadingRequestDelay,
    continueOnError,
    delegateLoadingBar
  } = computeRealValue(pick(pollOptions, ["interval", "leadingRequestDelay", "continueOnError", "delegateLoadingBar"]), runtimeContext);
  const currentRenderId = _internalApiGetRenderId();
  let currentTimeoutId;
  async function poll() {
    timeoutIdList.delete(currentTimeoutId);
    let shouldStop;
    try {
      var _computeRealValue;
      shouldStop = (_computeRealValue = computeRealValue(expectPollStopImmediately, runtimeContext)) === null || _computeRealValue === void 0 ? void 0 : _computeRealValue();
      // Stop polling immediately when the expectation is match before task.
      if (!shouldStop) {
        var _computeRealValue2;
        const result = await task();
        const expectPollStopImmediatelyResult = (_computeRealValue2 = computeRealValue(expectPollStopImmediately, runtimeContext)) === null || _computeRealValue2 === void 0 ? void 0 : _computeRealValue2();
        // Stop polling immediately when the expectation is match or a different router
        // is rendering after the task processed.
        shouldStop = expectPollStopImmediatelyResult || currentRenderId !== _internalApiGetRenderId();
        if (!shouldStop) {
          var _computeRealValue3;
          progress === null || progress === void 0 || progress(result);
          if ((_computeRealValue3 = computeRealValue(expectPollEnd, runtimeContext)) !== null && _computeRealValue3 !== void 0 && _computeRealValue3(result)) {
            if (delegateLoadingBar) {
              window.dispatchEvent(new Event("request.end"));
            }
            success === null || success === void 0 || success(result);
            finallyCallback === null || finallyCallback === void 0 || finallyCallback();
          } else {
            delayedPoll(interval !== null && interval !== void 0 ? interval : 3000);
          }
        } else if (expectPollStopImmediatelyResult) {
          finallyCallback === null || finallyCallback === void 0 || finallyCallback();
        }
      } else {
        finallyCallback === null || finallyCallback === void 0 || finallyCallback();
      }
    } catch (e) {
      var _computeRealValue4;
      const expectPollStopImmediatelyResult = (_computeRealValue4 = computeRealValue(expectPollStopImmediately, runtimeContext)) === null || _computeRealValue4 === void 0 ? void 0 : _computeRealValue4();
      // Stop polling immediately when the expectation is match or a different router
      // is rendering after the task processed.
      shouldStop = expectPollStopImmediatelyResult || currentRenderId !== _internalApiGetRenderId();
      if (!shouldStop) {
        error === null || error === void 0 || error(e);
        if (continueOnError) {
          delayedPoll(interval !== null && interval !== void 0 ? interval : 3000);
        } else {
          finallyCallback === null || finallyCallback === void 0 || finallyCallback();
        }
      } else if (expectPollStopImmediatelyResult) {
        finallyCallback === null || finallyCallback === void 0 || finallyCallback();
      }
    } finally {
      // Manually dispatch an event of `request.end` when the polling is stopped immediately.
      if (delegateLoadingBar && shouldStop) {
        window.dispatchEvent(new Event("request.end"));
      }
    }
  }
  function delayedPoll(delay) {
    currentTimeoutId = setTimeout(poll, delay);
    timeoutIdList.add(currentTimeoutId);
  }
  delayedPoll(leadingRequestDelay !== null && leadingRequestDelay !== void 0 ? leadingRequestDelay : 0);
  if (delegateLoadingBar) {
    window.dispatchEvent(new Event("request.start"));
  }
}
export function clearPollTimeout() {
  for (const timeoutId of timeoutIdList) {
    clearTimeout(timeoutId);
  }
  timeoutIdList.clear();
}
//# sourceMappingURL=poll.js.map